import r from "react";
import a from "./background.module.scss.js";
function s({
  image: e,
  imageResponsive: t,
  backdropColor: o,
  children: c
}) {
  return /* @__PURE__ */ r.createElement(
    "div",
    {
      "data-testid": "background",
      className: a.backgroundWrapper,
      style: {
        "--backdrop-color": o ?? ""
      }
    },
    /* @__PURE__ */ r.createElement(
      "div",
      {
        className: a.backdrop,
        style: {
          "--backdrop-image": `url(${e})`,
          "--backdrop-image-responsive": `url(${t || e})`
        }
      }
    ),
    c
  );
}
export {
  s as Background
};
//# sourceMappingURL=Background.js.map
